// LanguageSwitcher — small dropdown that switches the UI language.
// Hidden when the hotel only operates in one language (showSwitcher=false).
import React from 'react';
import { Box, Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { Globe, ChevronDown } from 'lucide-react';
import { useLocale } from './useLocale';

export default function LanguageSwitcher({ size = 'sm', variant = 'outline' }) {
  const { language, setLanguage, options, showSwitcher } = useLocale();
  if (!showSwitcher) return null;

  const current = options.find((o) => o.code === language) || options[0];

  return (
    <Menu>
      {/* Phone: icon-only (the label + chevron made the header wrap to
          two rows at 390px). Desktop keeps the full label. */}
      <MenuButton
        as={Button}
        size={size}
        variant={variant}
        leftIcon={<Globe size={14} />}
        rightIcon={<ChevronDown size={14} />}
        aria-label={current?.nativeLabel || current?.label || language}
        sx={{
          '@media (max-width: 47.99em)': {
            px: 2,
            '& .chakra-button__icon:first-of-type': { mr: 0 },
            '& .chakra-button__icon:last-of-type': { display: 'none' },
          },
        }}
      >
        <Box as="span" display={{ base: 'none', md: 'inline' }}>
          {current?.nativeLabel || current?.label || language}
        </Box>
      </MenuButton>
      <MenuList minW="160px">
        {options.map((opt) => (
          <MenuItem
            key={opt.code}
            onClick={() => setLanguage(opt.code)}
            fontWeight={opt.code === language ? 'semibold' : 'normal'}
          >
            {opt.nativeLabel}
            {opt.nativeLabel !== opt.label && (
              <span style={{ marginLeft: 6, color: '#888', fontSize: '0.85em' }}>
                ({opt.label})
              </span>
            )}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
